import { render } from "./GenericApproveRejectModal.vue?vue&type=template&id=eb2c73f6&scoped=true"
import script from "./GenericApproveRejectModal.js?vue&type=script&lang=js"
export * from "./GenericApproveRejectModal.js?vue&type=script&lang=js"

import "./GenericApproveRejectModal.vue?vue&type=style&index=0&id=eb2c73f6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb2c73f6"]])

export default __exports__